import { createContext, ReactNode, useMemo } from 'react';
import { useNullableContext } from 'shared/hooks/useNullableContext';
import { UpdateParams, useLocationParams } from 'shared/routing/LocationParams';

import {
  ReportsRevenueParamsDTO,
  reportsRevenueParamsSchema,
} from './ReportsDTO';

interface ReportsRevenueContext {
  params: ReportsRevenueParamsDTO;
  setParams: UpdateParams<ReportsRevenueParamsDTO>;
}

const Context = createContext<null | ReportsRevenueContext>(null);

export function useReportsRevenueContext() {
  return useNullableContext('ReportsRevenue', Context);
}

interface Props {
  children?: ReactNode;
}

export function ReportsRevenueContextProvider({ children }: Props) {
  const [params, setParams] = useLocationParams<ReportsRevenueParamsDTO>({
    zodSchema: reportsRevenueParamsSchema,
    persistName: 'ReportsRevenue',
  });

  const ctx = useMemo<ReportsRevenueContext>(
    () => ({ params, setParams }),
    [params, setParams],
  );

  return <Context.Provider value={ctx}>{children}</Context.Provider>;
}
